import { render, staticRenderFns } from "./tentof.vue?vue&type=template&id=7dbbc692&scoped=true&"
import script from "./tentof.vue?vue&type=script&lang=js&"
export * from "./tentof.vue?vue&type=script&lang=js&"
import style0 from "./tentof.vue?vue&type=style&index=0&id=7dbbc692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbbc692",
  null
  
)

export default component.exports